var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _g, _path8, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _line, _circle, _circle2, _line2, _line3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path9, _ellipse6, _ellipse7, _ellipse8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 219,
    viewBox: "0 0 347 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 347,
    height: 219,
    rx: 10,
    fill: "#111236"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M284.955 132.192L285.629 135.079L282.743 135.754L283.193 137.678L286.078 137.003L286.753 139.889L288.677 139.44L288.003 136.553L290.889 135.878L290.439 133.954L287.553 134.629L286.879 131.743L284.955 132.192Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M174.5 195L176.091 198.232L179 200L176.091 201.768L174.5 205L172.909 201.768L170 200L172.909 198.232L174.5 195Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M67.5 89L69.0913 92.2317L72 94L69.0913 95.7683L67.5 99L65.9087 95.7683L63 94L65.9087 92.2317L67.5 89Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M67.7121 58.9389L62.7746 52.863L57.8372 46.7871L55.05 43.3571C54.8957 43.1674 55.1337 42.8713 55.2879 43.0611L60.2254 49.137L65.1628 55.2129L67.95 58.6429C68.1043 58.8326 67.8663 59.1287 67.7121 58.9389Z",
    fill: "url(#paint0_linear_752_13854)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.7121 185.939L66.7746 179.863L61.8372 173.787L59.05 170.357C58.8957 170.167 59.1337 169.871 59.2879 170.061L64.2254 176.137L69.1628 182.213L71.95 185.643C72.1043 185.833 71.8663 186.129 71.7121 185.939Z",
    fill: "url(#paint1_linear_752_13854)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M291.5 89.5C291.5 91.7091 289.709 93.5 287.5 93.5C285.291 93.5 283.5 91.7091 283.5 89.5C283.5 87.2909 285.291 85.5 287.5 85.5C289.709 85.5 291.5 87.2909 291.5 89.5Z",
    stroke: "#E6EAEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.042 15.0128L162.151 16.8905L160.274 15L159.013 16.2516L160.891 18.1426L159 20.0209L160.252 21.2812L162.143 19.4035L164.021 21.294L165.282 20.0424L163.404 18.1514L165.295 16.2731L164.042 15.0128Z",
    fill: "#575973"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 37.8184,
    width: 150,
    height: 140,
    rx: 10,
    fill: "#DEDEDE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_752_13854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102 47.8184C102 42.2955 106.477 37.8184 112 37.8184H242C247.523 37.8184 252 42.2955 252 47.8184V167.818C252 173.341 247.523 177.818 242 177.818H112C106.477 177.818 102 173.341 102 167.818V47.8184Z",
    fill: "url(#paint2_linear_752_13854)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102 63.8184H252V167.818C252 173.341 247.523 177.818 242 177.818H112C106.477 177.818 102 173.341 102 167.818V63.8184Z",
    fill: "#F2F6FB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 71.001,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 142.527,
    y: 71.001,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 167.053,
    y: 71.001,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 191.58,
    y: 71.001,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 216.107,
    y: 71.001,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 95.5278,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 142.527,
    y: 95.5278,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 167.053,
    y: 95.5278,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 191.58,
    y: 95.5278,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 216.107,
    y: 95.5278,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 120.054,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 142.527,
    y: 120.054,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 167.053,
    y: 120.054,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 191.58,
    y: 120.054,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 216.107,
    y: 120.054,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 144.581,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 142.527,
    y: 144.581,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 167.053,
    y: 144.581,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 191.58,
    y: 144.581,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 216.107,
    y: 144.581,
    width: 20.8931,
    height: 20.8931,
    fill: "#E5EBF2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 102.5,
    y1: 63.3184,
    x2: 251.5,
    y2: 63.3184,
    stroke: "#1A1C42",
    strokeOpacity: 0.3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 136.176,
    cy: 50.4617,
    r: 6.22536,
    fill: "#F2F6FB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.595,
    cy: 50.4617,
    r: 6.22536,
    fill: "#F2F6FB"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 136.023,
    y1: 51.1973,
    x2: 136.023,
    y2: 32.2958,
    stroke: "#3F408E",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 219.443,
    y1: 51.1973,
    x2: 219.443,
    y2: 32.2958,
    stroke: "#3F408E",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.5,
    cy: 97,
    rx: 6.5,
    ry: 11,
    fill: "#1A1C42"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 158,
    cy: 91.5,
    rx: 3,
    ry: 3.5,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 161,
    cy: 98.5,
    rx: 1,
    ry: 1.5,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.5,
    cy: 97,
    rx: 6.5,
    ry: 11,
    fill: "#1A1C42"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 201,
    cy: 91.5,
    rx: 3,
    ry: 3.5,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155 125.975C163.833 118.142 191.5 110.475 210.5 125.975",
    stroke: "#1A1C42",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 205,
    cy: 96.5,
    rx: 1,
    ry: 1.5,
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 226,
    cy: 110,
    rx: 9,
    ry: 2,
    fill: "#FFC278"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 136,
    cy: 110,
    rx: 9,
    ry: 2,
    fill: "#FFC278"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_752_13854",
    x: 99,
    y: 34.8184,
    width: 158,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_752_13854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_752_13854",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_752_13854",
    x1: 68,
    y1: 51,
    x2: 55,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_752_13854",
    x1: 72,
    y1: 178,
    x2: 59,
    y2: 178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_752_13854",
    x1: 177,
    y1: 37.8184,
    x2: 176.81,
    y2: 61.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F99B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2591A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c88ee75301c484aa0fcf265baf51678e.svg";
export { ForwardRef as ReactComponent };